import React, { useState, useEffect, useMemo } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
	faSync,
	faTimesCircle,
	faCheck,
	faUpload,
} from "@fortawesome/free-solid-svg-icons"
import {
	ATELIER_ETAT_A_RESTITUER,
	ATELIER_ETAT_CLOS,
	ATELIER_ETAT_DEVIS,
	ATELIER_ETAT_DEVIS_A_FAIRE,
	ATELIER_ETAT_DEVIS_ACCEPTE,
	ATELIER_ETAT_DEVIS_REFUSE,
	ATELIER_ETAT_EN_ATTENTE_CLIENT,
	ATELIER_ETAT_CONTROLE_AVANT_FACTURATION,
	ATELIER_ETAT_EN_ATTENTE_PAIEMENT,
	ATELIER_ETAT_OK_POUR_FACTURATION,
	ATELIER_ETAT_TRAVAUX_EN_COURS,
	ATELIER_ETAT_TRAVAUX_TERMINES,
	isValidEmail,
} from "../../utilities/Addons"
import * as Addons from "../../utilities/Addons"
import {
	PAYE_PAR_ASSURANCE,
	PAYE_PAR_CLIENT,
	PAYE_PAR_MASTER,
} from "./AtelierLigneV2"
import { getBaseTransactionV2 } from "../../store/reducers/atelierReducer"
import { appliquerPerte } from "../../utilities/transactionsV2"
import { filtrerMoyensPaiement } from "../../hooks/moyenPaiement"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import {
	deleteAtelier,
	deleteAtelierReset,
} from "../../store/actions/atelierSearchActions"
import {
	createWinbizFacture,
	declareWinbizManuel,
} from "../../store/actions/winbizActions"
import { URL } from "../../store/actions/depannageActions"
import { handleErrors, normalizeApiError } from "../../store/actions/apiHelpers"
import { useRights } from "../../hooks/rights"
import CustomModal from "../basics/interface/CustomModal"
import { generalStyles } from "../styles/styles"
import { COLORS } from "../../utilities/Constants"
import {
	filterEmployesActifs,
	filterEmployesGroupe,
} from "../../utilities/employes"

// Version V2 (CustomModal) de SaveAtelier (SaveModal) — machine à états des
// transitions de la fiche atelier. Logique métier identique au legacy ; seule la
// coque react-responsive-modal devient CustomModal. Props identiques.
const SaveAtelierV2 = (props) => {
	const {
		obj,
		etat,
		next,
		svp,
		mdps,
		employes,
		atelier,
		totClient,
		totAssurance,
		totMaster,
		restePayerFacturation,
		closeModal,
		save,
		nextEtat,
		setRestitution,
		// Revue 27.10 (I1) : relit les transactions de la fiche (date posée au
		// dépôt d'une facture) avant la transition suivante.
		refreshTransactions,
		// Génération d'un devis manquant sur une fiche déjà au-delà de l'état Devis :
		// affiche le même popup que l'étape Devis mais sans changer l'état (keepEtat).
		forceDevis = false,
		factureOnly = false,
	} = props

	const dispatch = useDispatch()
	const history = useHistory()

	// Le doc de restitution est géré hors `form` (upload/suppression via redux) → on
	// lit son état depuis le store, pas depuis le prop `atelier` (snapshot du form).
	const { token } = useSelector((state) => state.navInfo.login)
	const { entite, atelier: reduxAtelier } = useSelector(
		(state) => state.atelierInfo,
	)
	const { employes: depanneurs } = useSelector((state) => state.masterReducer)
	const { deleting, deleted } = useSelector(
		(state) => state.atelierSearchInfo.deleteAtelier,
	)

	const [state, setState] = useState({
		switchState: false,
		sousReserve: false,
		mdp: 0,
		payeParSelect: PAYE_PAR_CLIENT,
		caissier: 0,
		tarif: Addons.round20(totClient),
		selectedDepanneur: atelier.employe,
		winbizLoading: false,
		winbizDone: false,
		winbizResults: [],
		winbizUploadedPdfs: [],
		winbizUploadErreur: null,
		winbizManuel: false,
		winbizManuelNumeros: {},
		// GE-77 : décochée par défaut (Jordan 27.10, clics rapides).
		remettreDegats: false,
	})

	const keyListeners = (e) => {
		if (e.key !== "Enter") return
		if (obj.errorFields.length > 0) closeModal()
		else if (
			!obj.saving &&
			!obj.error &&
			!obj.saved &&
			obj.errorFields.length === 0
		)
			save()
		else if (obj.saved || obj.error) closeModal()
	}

	useEffect(() => {
		document.addEventListener("keydown", keyListeners)
		return () => document.removeEventListener("keydown", keyListeners)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [obj, save, closeModal])

	const updateState = (field, e) => {
		let value = e.target.value
		if (["caissier", "mdp"].includes(field)) value = parseInt(value)
		setState({ ...state, [field]: value })
	}

	const vehiculeRestitue = () => {
		if (totClient > 0) setState({ ...state, switchState: true })
		else restituer()
	}

	const restituer = () => {
		let transactions = []
		if (totAssurance > 0) {
			transactions.push({
				...getBaseTransactionV2(),
				id: Math.random(),
				atelier: atelier.id,
				moyenPaie:
					(mdps.find((m) => m.nom === "Facture") || {}).id || 0,
				payeParSelect: PAYE_PAR_ASSURANCE,
				caissier: atelier.employe,
				total: Addons.round100(totAssurance),
			})
		}
		if (totClient > 0) {
			transactions.push({
				...getBaseTransactionV2(),
				id: Math.random(),
				atelier: atelier.id,
				moyenPaie: state.mdp,
				payeParSelect: PAYE_PAR_CLIENT,
				caissier: state.caissier,
				total: Addons.round100(state.tarif),
			})
		}
		if (totMaster > 0) {
			transactions.push(
				appliquerPerte({
					...getBaseTransactionV2(),
					id: Math.random(),
					atelier: atelier.id,
					payeParSelect: PAYE_PAR_MASTER,
					raison: "Rabais franchise",
					details: "",
					total: Addons.round100(totMaster),
				}),
			)
		}
		setRestitution(transactions)
	}

	const isReadyToBeClosed = () => false
	const shouldCreateFacture = () => restePayerFacturation !== 0

	const _delete = () =>
		dispatch(deleteAtelier(JSON.stringify({ id: atelier.id })))
	// Boss + admin (GE-69 lot 1) ; le serveur fait foi.
	const peutSupprimer = useRights().hasRight("atelier_suppression")
	const afterDelete = () => {
		history.goBack()
		dispatch(deleteAtelierReset())
		dispatch({ type: "RESET_ATELIER" })
	}

	const mdpsClientFiltered = useMemo(
		() =>
			filtrerMoyensPaiement(mdps, {
				module: "ate",
				entite,
				payeParSelect: PAYE_PAR_CLIENT,
				valeurCourante: state.mdp,
			}),
		[mdps, entite, state.mdp],
	)

	const { switchState, sousReserve, mdp, payeParSelect, caissier, tarif } =
		state

	const centered = {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: 10,
		padding: "8px 0",
	}

	// Helper : confirmation Oui / Non simple.
	const ouiNon = (title, onOui, opts = {}) => (
		<CustomModal
			title={title}
			onClose={closeModal}
			showCloseButton={false}
			buttons={[
				{
					title: "Non",
					styleName: "secondary",
					onClick: opts.onNon || closeModal,
				},
				{
					title: "Oui",
					styleName: "primary",
					onClick: onOui,
					disabled: opts.disabled,
				},
			]}
		>
			{opts.children}
		</CustomModal>
	)

	// 1. Erreurs de validation
	if (obj.errorFields.length > 0) {
		return (
			<CustomModal
				title={"Erreurs sur les champs suivants"}
				onClose={closeModal}
				showCloseButton={false}
				buttons={[
					{ title: "Ok", styleName: "primary", onClick: closeModal },
				]}
			>
				<div style={centered}>
					{obj.errorFields.map((field, index) => (
						<div key={index}>{field}</div>
					))}
				</div>
			</CustomModal>
		)
	}

	// 2. Devis à faire → commencer le devis
	if (etat === ATELIER_ETAT_DEVIS_A_FAIRE && next) {
		return ouiNon("Commencer le devis ?", () =>
			nextEtat(ATELIER_ETAT_DEVIS),
		)
	}

	// 3. Devis → génération (sous réserve + e-mail / impression). Déclenché par
	// l'étape suivante depuis l'état Devis, ou par « Générer devis » (forceDevis)
	// sur une fiche plus avancée — auquel cas keepEtat conserve l'état courant.
	if (
		(etat === ATELIER_ETAT_DEVIS && next) ||
		(forceDevis && !obj.saving && !obj.saved && !obj.error)
	) {
		return (
			<CustomModal
				title={"Génération du devis"}
				onClose={closeModal}
				buttons={[
					{
						title: "Envoyer par e-mail",
						styleName: "secondary",
						disabled: !isValidEmail(entite.email),
						onClick: () =>
							nextEtat(ATELIER_ETAT_EN_ATTENTE_CLIENT, {
								sousReserve,
								imprimerDevis: false,
								keepEtat: forceDevis,
							}),
					},
					{
						title: "Imprimer",
						styleName: "primary",
						onClick: () =>
							nextEtat(ATELIER_ETAT_EN_ATTENTE_CLIENT, {
								sousReserve,
								imprimerDevis: true,
								keepEtat: forceDevis,
							}),
					},
				]}
			>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						gap: 12,
					}}
				>
					<label style={generalStyles.label}>
						Sous réserve de démontage
					</label>
					<input
						type="checkbox"
						checked={sousReserve}
						onChange={() =>
							setState((prev) => ({
								...prev,
								sousReserve: !prev.sousReserve,
							}))
						}
						style={{ height: 20, width: 20 }}
					/>
				</div>
			</CustomModal>
		)
	}

	// 4. En attente client → accepté / refusé (garder en 12 ou supprimer)
	if (etat === ATELIER_ETAT_EN_ATTENTE_CLIENT && next) {
		if (switchState && deleting) {
			return (
				<CustomModal
					title={"Suppression..."}
					showFooter={false}
					showCloseButton={false}
					onClose={closeModal}
				>
					<div style={centered}>
						<FontAwesomeIcon icon={faSync} size="2x" spin />
					</div>
				</CustomModal>
			)
		}
		if (switchState && deleted) {
			return (
				<CustomModal
					title={"Suppression terminée"}
					onClose={afterDelete}
					showCloseButton={false}
					buttons={[
						{
							title: "Fermer",
							styleName: "primary",
							onClick: afterDelete,
						},
					]}
				>
					<div style={centered}>
						<FontAwesomeIcon
							icon={faCheck}
							size="2x"
							style={{ color: COLORS.success }}
						/>
					</div>
				</CustomModal>
			)
		}
		// Devis refusé : garder la fiche (état 12, hors recherche à vide) ou
		// la supprimer ; Annuler la laisse en attente client.
		if (switchState) {
			return (
				<CustomModal
					title={"Devis refusé — que faire de la fiche ?"}
					onClose={closeModal}
					showCloseButton={false}
					buttons={[
						{
							title: "Annuler",
							styleName: "secondary",
							onClick: closeModal,
						},
						...(peutSupprimer
							? [
									{
										title: "Supprimer la fiche",
										styleName: "danger",
										onClick: _delete,
									},
								]
							: []),
						{
							title: "Garder la fiche",
							styleName: "primary",
							onClick: () => nextEtat(ATELIER_ETAT_DEVIS_REFUSE),
						},
					]}
				/>
			)
		}
		return ouiNon(
			"Le client a accepté le devis ?",
			() => nextEtat(ATELIER_ETAT_DEVIS_ACCEPTE, { devisAccepte: true }),
			{ onNon: () => setState({ ...state, switchState: true }) },
		)
	}

	// 5. Devis accepté → commencer les travaux (choix mécanicien)
	if (etat === ATELIER_ETAT_DEVIS_ACCEPTE && next) {
		return ouiNon(
			"Commencer les travaux ?",
			() =>
				nextEtat(ATELIER_ETAT_TRAVAUX_EN_COURS, {
					employeId: state.selectedDepanneur,
				}),
			{
				disabled: state.selectedDepanneur === 0,
				children: (
					<div style={generalStyles.fieldRow}>
						<label style={generalStyles.label}>Mécanicien</label>
						<select
							style={generalStyles.select}
							value={state.selectedDepanneur}
							onChange={(e) =>
								setState({
									...state,
									selectedDepanneur: parseInt(e.target.value),
								})
							}
						>
							<option value={0}>-</option>
							{/* Mécanicien = même règle que la fiche
							    (groupe employe + actifs). */}
							{filterEmployesGroupe(
								depanneurs,
								state.selectedDepanneur,
							).map((d) => (
								<option key={`dep_${d.id}`} value={d.id}>
									{d.nom}
								</option>
							))}
						</select>
					</div>
				),
			},
		)
	}

	// 6/7. Travaux en cours → terminés (libellé selon svp)
	if (etat === ATELIER_ETAT_TRAVAUX_EN_COURS && next && !svp) {
		return ouiNon("Les travaux sont terminés ?", () =>
			nextEtat(ATELIER_ETAT_TRAVAUX_TERMINES),
		)
	}
	if (etat === ATELIER_ETAT_TRAVAUX_EN_COURS && next && svp) {
		return ouiNon("L'entretien a été effectué ?", () =>
			nextEtat(ATELIER_ETAT_TRAVAUX_TERMINES),
		)
	}

	// 8/9. Travaux terminés → restituer / clore (selon svp)
	if (etat === ATELIER_ETAT_TRAVAUX_TERMINES && next && !svp) {
		return ouiNon("Le véhicule est prêt à être restitué ?", () =>
			nextEtat(ATELIER_ETAT_A_RESTITUER),
		)
	}
	if (etat === ATELIER_ETAT_TRAVAUX_TERMINES && next && svp) {
		// GE-77 : entretien d'un véhicule de location → proposer la remise à
		// zéro de ses dégâts (plus repris au départ suivant). Tout ou rien.
		return ouiNon(
			"Clore l'entretien ?",
			() =>
				nextEtat(ATELIER_ETAT_CLOS, {
					remettreDegatsAZero:
						!!atelier.remise_degats_proposee &&
						state.remettreDegats,
				}),
			{
				children: atelier.remise_degats_proposee ? (
					<label
						style={{
							display: "flex",
							alignItems: "center",
							gap: 8,
							fontSize: 13,
							cursor: "pointer",
						}}
					>
						<input
							type="checkbox"
							checked={state.remettreDegats}
							onChange={(e) =>
								setState({
									...state,
									remettreDegats: e.target.checked,
								})
							}
						/>
						Dégâts réparés : remettre à zéro les dégâts du véhicule
					</label>
				) : null,
			},
		)
	}

	// 10. À restituer (assurance) sans document → demander l'upload (état du doc lu
	// depuis le store, où l'upload est réellement enregistré — pas le snapshot form).
	if (
		etat === ATELIER_ETAT_A_RESTITUER &&
		next &&
		atelier.isAssurance &&
		!(reduxAtelier.doc_restitution && reduxAtelier.doc_restitution.saved)
	) {
		return (
			<CustomModal
				title={"Uploader le document de restitution"}
				onClose={closeModal}
				showCloseButton={false}
				buttons={[
					{
						title: "Fermer",
						styleName: "secondary",
						onClick: closeModal,
					},
				]}
			/>
		)
	}

	// 11. À restituer → restituer le véhicule (+ transaction client si nécessaire)
	if (etat === ATELIER_ETAT_A_RESTITUER && next) {
		if (!switchState) {
			return ouiNon("Restituer le véhicule ?", vehiculeRestitue)
		}
		const disabled =
			mdp === 0 || payeParSelect === -1 || caissier === 0 || tarif === ""
		return (
			<CustomModal
				title={"Ajouter une transaction client"}
				onClose={closeModal}
				showCloseButton={false}
				buttons={[
					{
						title: "Annuler",
						styleName: "secondary",
						onClick: closeModal,
					},
					{
						title: "Sauvegarder",
						styleName: "primary",
						onClick: restituer,
						disabled,
					},
				]}
			>
				<div style={generalStyles.fieldRow}>
					<label style={generalStyles.label}>Moyen de paiement</label>
					<select
						style={generalStyles.select}
						value={mdp}
						onChange={(e) => updateState("mdp", e)}
					>
						<option value={0}>-</option>
						{mdpsClientFiltered.map((m) => (
							<option key={`mdp${m.id}`} value={m.id}>
								{m.nom}
							</option>
						))}
					</select>
				</div>
				<div style={generalStyles.fieldRow}>
					<label style={generalStyles.label}>Caissier</label>
					<select
						style={generalStyles.select}
						value={caissier}
						onChange={(e) => updateState("caissier", e)}
					>
						<option value={0}>-</option>
						{filterEmployesActifs(employes, caissier).map((emp) => (
							<option key={`emp${emp.id}`} value={emp.id}>
								{emp.nom}
							</option>
						))}
					</select>
				</div>
				<div style={generalStyles.fieldRow}>
					<label style={generalStyles.label}>Tarif</label>
					<input
						type="text"
						style={generalStyles.input}
						value={tarif}
						onChange={(e) => updateState("tarif", e)}
						onKeyDown={(e) => Addons.typeNumber(e)}
					/>
				</div>
			</CustomModal>
		)
	}

	// 12. Contrôle avant facturation → prête pour la facturation
	if (etat === ATELIER_ETAT_CONTROLE_AVANT_FACTURATION && next) {
		return ouiNon("Fiche prête pour la facturation ?", () =>
			nextEtat(ATELIER_ETAT_OK_POUR_FACTURATION),
		)
	}

	// 13. OK pour facturation → création facture WinBIZ + PDF
	if (
		(etat === ATELIER_ETAT_OK_POUR_FACTURATION &&
			next &&
			shouldCreateFacture()) ||
		(factureOnly && !obj.saving && !obj.saved && !obj.error)
	) {
		const txFacture = (atelier.transactionsv2 || []).filter(
			(t) =>
				mdps.find((m) => m.id === t.moyenPaie)?.nom === "Facture" &&
				t.payeParSelect !== PAYE_PAR_MASTER,
		)

		const txStatus = txFacture.map((t) => ({
			id: t.id,
			hasNumero: !!(
				t.extra_data?.winbiz?.numero || t.extra_data?.winbiz?.manuel
			),
			numero: t.extra_data?.winbiz?.numero || "",
			hasPdf: !!t.facture,
		}))
		const allReady = txStatus.every((s) => s.hasNumero && s.hasPdf)

		if (allReady && !state.winbizDone) {
			return ouiNon(
				"Factures et PDF prêts. Passer en attente de paiement ?",
				() => nextEtat(ATELIER_ETAT_EN_ATTENTE_PAIEMENT),
			)
		}

		const handleCreateWinbiz = () => {
			setState((s) => ({ ...s, winbizLoading: true }))
			const pending = txFacture.filter(
				(t) => !t.extra_data?.winbiz?.numero,
			)
			Promise.all(
				pending.map((t) => dispatch(createWinbizFacture(t.id))),
			).then((results) => {
				const ok = results.filter(Boolean)
				setState((s) => ({
					...s,
					winbizLoading: false,
					winbizDone: true,
					winbizResults: ok,
				}))
			})
		}

		const handleManuel = () => {
			setState((s) => ({ ...s, winbizManuel: true }))
		}

		const handleManuelConfirm = () => {
			setState((s) => ({ ...s, winbizLoading: true }))
			const pending = txFacture.filter(
				(t) =>
					!(
						t.extra_data?.winbiz?.numero ||
						t.extra_data?.winbiz?.manuel
					),
			)
			Promise.all(
				pending.map((t) =>
					dispatch(
						declareWinbizManuel(
							t.id,
							(state.winbizManuelNumeros[t.id] || "").trim(),
						),
					),
				),
			).then((results) => {
				setState((s) => ({
					...s,
					winbizLoading: false,
					winbizDone: true,
					winbizResults: results.filter(Boolean),
				}))
			})
		}

		// Revue 27.10 (R1) : le PDF n'est marqué déposé que sur un 200 ;
		// sinon le message du serveur s'affiche dans la modal.
		const handleUploadPdf = async (txId, file) => {
			const formData = new FormData()
			formData.append("id", atelier.id)
			formData.append(`facture_${txId}`, file)
			try {
				await fetch(`${URL}api/transactionv2`, {
					method: "put",
					headers: { Authorization: `Bearer ${token}` },
					body: formData,
				}).then(handleErrors)
				if (refreshTransactions) await refreshTransactions()
				setState((s) => ({
					...s,
					winbizUploadErreur: null,
					winbizUploadedPdfs: [...(s.winbizUploadedPdfs || []), txId],
				}))
			} catch (err) {
				const { message } = await normalizeApiError(err)
				setState((s) => ({ ...s, winbizUploadErreur: message }))
			}
		}

		if (state.winbizDone) {
			const updatedStatus = txStatus.map((s) => {
				const result = (state.winbizResults || []).find(
					(r) => r.transaction_id === s.id,
				)
				return {
					...s,
					hasNumero:
						s.hasNumero ||
						!!(result && (result.numero || result.ok)),
					numero: result?.numero || s.numero,
					hasPdf:
						s.hasPdf ||
						(state.winbizUploadedPdfs || []).includes(s.id),
				}
			})
			const canTransition = updatedStatus.every(
				(s) => s.hasNumero && s.hasPdf,
			)

			return (
				<CustomModal
					title="Facture WinBIZ"
					onClose={closeModal}
					showCloseButton={false}
					buttons={[
						{
							title: "Passer en attente de paiement",
							styleName: canTransition ? "primary" : "disabled",
							onClick: canTransition
								? () =>
										nextEtat(
											ATELIER_ETAT_EN_ATTENTE_PAIEMENT,
										)
								: undefined,
						},
						{
							title: "Fermer",
							styleName: "secondary",
							onClick: closeModal,
						},
					]}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							gap: 12,
							padding: "4px 0",
						}}
					>
						{updatedStatus.map((s) => (
							<div
								key={s.id}
								style={{
									display: "flex",
									alignItems: "center",
									gap: 10,
									padding: "8px 12px",
									backgroundColor: COLORS.bg,
									borderRadius: 8,
									border: `1px solid ${COLORS.border}`,
								}}
							>
								<div
									style={{
										flex: 1,
										fontSize: 13,
									}}
								>
									<div
										style={{
											display: "flex",
											alignItems: "center",
											gap: 6,
										}}
									>
										<FontAwesomeIcon
											icon={
												s.hasNumero
													? faCheck
													: faTimesCircle
											}
											color={
												s.hasNumero
													? COLORS.success
													: COLORS.danger
											}
											style={{ width: 14 }}
										/>
										<span>
											N°{" "}
											{s.numero ||
												(s.hasNumero
													? "saisie manuelle"
													: "manquant")}
										</span>
									</div>
									<div
										style={{
											display: "flex",
											alignItems: "center",
											gap: 6,
											marginTop: 4,
										}}
									>
										<FontAwesomeIcon
											icon={
												s.hasPdf
													? faCheck
													: faTimesCircle
											}
											color={
												s.hasPdf
													? COLORS.success
													: COLORS.danger
											}
											style={{ width: 14 }}
										/>
										<span>
											PDF{" "}
											{s.hasPdf ? "joint" : "manquant"}
										</span>
									</div>
								</div>
								{!s.hasPdf && (
									<label
										style={{
											display: "inline-flex",
											alignItems: "center",
											gap: 6,
											padding: "6px 12px",
											borderRadius: 8,
											border: `1px solid ${COLORS.border}`,
											backgroundColor: COLORS.surface,
											cursor: "pointer",
											fontSize: 12,
											fontWeight: 500,
											color: COLORS.text,
										}}
									>
										<FontAwesomeIcon icon={faUpload} />
										Joindre PDF
										<input
											type="file"
											accept=".pdf"
											style={{ display: "none" }}
											onChange={(e) => {
												if (e.target.files[0])
													handleUploadPdf(
														s.id,
														e.target.files[0],
													)
											}}
										/>
									</label>
								)}
							</div>
						))}
						{updatedStatus.some((s) => !s.hasPdf) && (
							<div
								style={{
									fontSize: 12,
									color: COLORS.textMuted,
									lineHeight: 1.4,
								}}
							>
								Téléchargez le PDF depuis WinBIZ (Envoyer → PDF)
								puis joignez-le ici.
							</div>
						)}
						{state.winbizUploadErreur && (
							<div
								style={{
									fontSize: 12,
									color: COLORS.danger,
									lineHeight: 1.4,
								}}
							>
								PDF non joint : {state.winbizUploadErreur}
							</div>
						)}
					</div>
				</CustomModal>
			)
		}

		if (state.winbizLoading) {
			return (
				<CustomModal
					title="Création de la facture WinBIZ…"
					showFooter={false}
					showCloseButton={false}
					onClose={closeModal}
				>
					<div style={centered}>
						<FontAwesomeIcon icon={faSync} size="2x" spin />
					</div>
				</CustomModal>
			)
		}

		if (state.winbizManuel) {
			const pendingManuel = txFacture.filter(
				(t) =>
					!(
						t.extra_data?.winbiz?.numero ||
						t.extra_data?.winbiz?.manuel
					),
			)
			return (
				<CustomModal
					title="Déclarer la facture créée manuellement"
					onClose={() =>
						setState((s) => ({ ...s, winbizManuel: false }))
					}
					showCloseButton={false}
					buttons={[
						{
							title: "Confirmer",
							styleName: "primary",
							onClick: handleManuelConfirm,
						},
						{
							title: "Annuler",
							styleName: "secondary",
							onClick: () =>
								setState((s) => ({
									...s,
									winbizManuel: false,
								})),
						},
					]}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							gap: 10,
							padding: "4px 0",
						}}
					>
						{pendingManuel.map((t) => (
							<div key={t.id} style={generalStyles.fieldRow}>
								<label style={generalStyles.label}>
									{pendingManuel.length > 1
										? `N° WinBIZ — tx ${t.id}`
										: "N° de facture WinBIZ"}
									{" (facultatif)"}
								</label>
								<input
									type="text"
									style={generalStyles.input}
									value={
										state.winbizManuelNumeros[t.id] || ""
									}
									onChange={(e) => {
										// Lire la valeur AVANT le setState : React 16
										// recycle l'événement (pooling) et e.target vaut
										// null quand l'updater différé s'exécute.
										const { value } = e.target
										setState((s) => ({
											...s,
											winbizManuelNumeros: {
												...s.winbizManuelNumeros,
												[t.id]: value,
											},
										}))
									}}
									placeholder="Laisser vide si inconnu"
								/>
							</div>
						))}
					</div>
				</CustomModal>
			)
		}

		return (
			<CustomModal
				title="Créer la facture WinBIZ"
				onClose={closeModal}
				showCloseButton={false}
				buttons={[
					{
						title: "Créer la facture",
						styleName: "primary",
						onClick: handleCreateWinbiz,
					},
					{
						title: "Déclarée à la main",
						styleName: "secondary",
						onClick: handleManuel,
					},
					{
						title: "Annuler",
						styleName: "secondary",
						onClick: closeModal,
					},
				]}
			>
				<div style={centered}>
					{txFacture.length === 1
						? `Créer 1 facture débiteur dans WinBIZ pour cette fiche ?`
						: `Créer ${txFacture.length} facture(s) dans WinBIZ ?`}
				</div>
			</CustomModal>
		)
	}

	// 14. En attente paiement → clore (isReadyToBeClosed = false → inactif)
	if (
		etat === ATELIER_ETAT_EN_ATTENTE_PAIEMENT &&
		next &&
		isReadyToBeClosed()
	) {
		return ouiNon("Clore la fiche ?", () => nextEtat(ATELIER_ETAT_CLOS))
	}

	// 15. Sauvegarde simple
	if (
		!obj.saving &&
		!obj.error &&
		!obj.saved &&
		obj.errorFields.length === 0
	) {
		return ouiNon("Sauvegarder ?", () => save())
	}

	// 16/17/18. Feedback de sauvegarde
	if (obj.saving) {
		return (
			<CustomModal
				title={"Sauvegarde..."}
				showFooter={false}
				showCloseButton={false}
				onClose={closeModal}
			>
				<div style={centered}>
					<FontAwesomeIcon icon={faSync} size="2x" spin />
				</div>
			</CustomModal>
		)
	}
	if (obj.saved) {
		return (
			<CustomModal
				title={"Sauvegarde terminée"}
				onClose={closeModal}
				showCloseButton={false}
				buttons={[
					{
						title: "Fermer",
						styleName: "primary",
						onClick: closeModal,
					},
				]}
			>
				<div style={centered}>
					<FontAwesomeIcon
						icon={faCheck}
						size="2x"
						style={{ color: COLORS.success }}
					/>
				</div>
			</CustomModal>
		)
	}
	if (obj.error) {
		return (
			<CustomModal
				title={"Erreur"}
				onClose={closeModal}
				showCloseButton={false}
				buttons={[
					{ title: "Ok", styleName: "primary", onClick: closeModal },
				]}
			>
				<div style={centered}>
					<FontAwesomeIcon
						icon={faTimesCircle}
						size="2x"
						style={{ color: COLORS.danger }}
					/>
					{obj.error.status && <div>{`${obj.error.status}`}</div>}
					<div>
						{obj.error.message ||
							obj.error.msg ||
							"La sauvegarde a échoué."}
					</div>
				</div>
			</CustomModal>
		)
	}
	return null
}

export default SaveAtelierV2
